__turbopack_context__.v({
  "img": "ImgWrapper-module-scss-module__7IaDaG__img",
  "imgWrapper": "ImgWrapper-module-scss-module__7IaDaG__imgWrapper",
});
